import React from 'react'

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer">
        by erica chai
      </footer>
    )
  }
}

export default Footer
